
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...query]",
      function () {
        return require("private-next-pages/[...query].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...query]"])
      });
    }
  